import { Box } from '@material-ui/core';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { Product } from '@setvi/shared/interfaces';
import { toTitleCase } from '@setvi/shared/utils/formatCustomerData';
import { ProductLabel } from 'componentsV2';

interface ManufacturerProps {
  product: Product;
}

export const Manufacturer = ({ product }: ManufacturerProps) => (
  <Box display="flex" flexDirection="column" gridGap="4px">
    <Box display="flex" gridGap="4px">
      <SText
        lineHeight="24px"
        maxLines={2}
        title={toTitleCase(product?.vendor?.name || 'Not Available')}
      />
      {(product?.privateLabel || product?.isPrivateLabel) && <ProductLabel />}
      {(product?.vendorHierarchy > 0 || product?.vendorRanking > 0) && (
        <ProductLabel type="strategic-vendor" />
      )}
    </Box>

    {product?.manufacturerSku && (
      <SText
        lineHeight="20px"
        title={product?.manufacturerSku}
        size="sm"
        fontColor={TextColor.SlateGrey}
      />
    )}
  </Box>
);
